import { accountQueryKeys } from 'queries/account-query-keys';
import { transactionQueryKeys } from 'queries/transaction-query-keys';
import { ReportResource } from 'types/domain';

const queryKeyStrategy = (resource: ReportResource) => {
    switch (resource) {
        case 'contacts':
        case 'companies':
            return accountQueryKeys.contactsWithFilters;
        case 'transactions':
            return transactionQueryKeys.transactionsWithFilters;
        case 'tickets':
            return accountQueryKeys.ticketsWithFilters;
        case 'campaigns':
            return accountQueryKeys.campaignsWithFilters;
        case 'transaction_plans':
            return accountQueryKeys.plansWithFilters;
        case 'pledges':
            return accountQueryKeys.pledgesWithParams;
    }
};

export { queryKeyStrategy };
